import React from "react"
import { Dialog } from "primereact/dialog"
import { useFormikContext } from "formik"
import { Button } from "primereact/button"
import styles from "../../../styles/Participant-Profile.module.css"

export default function ConsentDialog(props) {
  const formik = useFormikContext()

  const handleButton = () => {
    return (
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem", marginTop: "1.5rem" }}>
        <Button
          onClick={async () => {
            formik.setFieldValue("consent_data_store", "Yes")
            props.setDialog(false)
          }}
          className="p-button-rounded p-button-secondary"
          style={{ padding: "0.8rem", width: '100px' }}
          label="Cancel"
        />
        <Button
          onClick={async () => {
            formik.setFieldValue("consent_data_store", "No")
            props.setDialog(false)
          }}
          className="p-button-rounded"
          style={{ padding: "0.8rem", width: '362px' }}
          label="Yes, terminate my RecoveryLink services"
        />
      </div>
    )
  }

  const handleOnHide = () => {
    formik.setFieldValue("consent_data_store", "Yes")
    props.setDialog(false)
  }

  return (
    <Dialog
      header={"Consent for Services"}
      visible={props.dialog}
      style={{ width: "50vw" }}
      onHide={handleOnHide}
      content={({ hide }) => (
        <div className={styles.concent_dialog}>
          <strong style={{ color: "#383838" }}>Consent for services</strong>
          <p style={{ marginTop: "0.6rem" }}>
            Revoking your consent will initiate termination of services with all
            engaged Organizations, and will move your personal health information
            into RecoveryLink PHI deletion protocol.
          </p>
          <p>
            Do you understand that this action will terminate all RecoveryLink
            services, will delete all participant data, and will terminate this
            participant account permanently?
          </p>
          {handleButton()}
        </div>
      )}
    >
    </Dialog>
  )
}
